import React from 'react';
import BaseTeamDetails from '../base-team-details';

class TeamDetailsComponent extends BaseTeamDetails {
    render() {
        const teamSpread = this.getTeamTotalValue();
        const teamTotal = (Number(this.props.game.gameTotal) - Number(teamSpread)) / 2;
        return (
            <span className="spread-text">
                Team Total: <strong>{teamTotal}</strong>
            </span>
        );
    }
}

export {TeamDetailsComponent};
